<template>
  <!-- 勤務表 親コンポーネント -->
  <div id="roster">
    <CCard>
      <div v-if="!fromExternal">
        <CCardHeader>
          <h2>勤務表</h2>
        </CCardHeader>
        <CCardBody>
          <table class="table search-table">
            <tr>
              <th style="width: 100px">年月</th>
              <th style="width: 75px"></th>
              <th style="width: 50px"></th>
              <th></th>
            </tr>
            <tr>
              <td>
                <select
                  class="custom-select"
                  v-model="year"
                  style="width: 90px"
                >
                  <option
                    v-for="option in yearOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  class="custom-select"
                  v-model="month"
                  style="width: 70px"
                >
                  <option
                    v-for="option in monthOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>業務分</td>
              <td>
                <save-button
                  :label="'表示'"
                  @click="callList"
                  />
              </td>
            </tr>
          </table>
        </CCardBody>
      </div>
      <template v-if="displayFlg">
        <div v-if="!fromExternal">
          <CRow class="justify-content-start" 
          style="padding-right: 25px
          ;padding-left: 25px"
          >
            <CCard
              style="width: 415px; height: 260px; color: white"
              color="info"
              class="card-body pb-3"
            >
              <CCardHeader>
                <strong style="font-size: 20px; font-weight: bold">
                  入力手順
                </strong>
              </CCardHeader>
              <CCardBody style="font-size: 15px">
                1.開始時刻、終了時刻、休憩に時間を入力<br/>
                  （入力例：09:00,18:00,01:00）<br/>
                2.勤怠1を選択し、勤怠2は勤怠1で<br/>
                「午前出勤」「午前有給」「午前代休」<br/>
                「午前欠勤」「早出出勤」選択時に選択<br/>
                3.備考・作業内容を入力し、入力内容に<br/>
                不備がなければ「保存」ボタンを押下
              </CCardBody>
            </CCard>
            <CCard
              style="width: 415px; height: 260px; color: white"
              color="success"
              class="card-body pb-3"
            >
              <CCardHeader>
                <strong style="font-size: 20px; font-weight: bold">
                  tsvファイル読込
                </strong>(β版)
              </CCardHeader>
              <CCardBody style="font-size: 15px">
                <input type="file" @change="readfile" /><br/><br/>
                ※スプレットシート・エクセルのみ対応<br/>
                ※行フォーマット：開始時刻	終了時刻<br/>
                ※読み込みファイル拡張子は任意<br/>
                ※フォーマットチェック無
              </CCardBody>
            </CCard>
          </CRow>
        </div>
        <CCardHeader>
          <strong
            v-if="showYearMonth"
            style="font-size: 20px; font-weight: bold"
          >
            {{ selectYear }} 年 {{ selectMonth }} 月
            <span style="margin-left: 10px"></span>
            <span :style="statusColor(status[0])">【{{ getStatusLabel(status[0]) }}】</span>
          </strong>
        </CCardHeader>
        <CCardBody>
          <ValidationObserver ref="obs">
            <td v-if="errors.length">
              <div style="color: red" v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </td>
            <form
              class="edit-form"
              name="edit"
              action="/change"
              method="post"
              @submit.prevent="edit"
            >
              <div class="edit-form__group">
                <RosterError
                  ref="error"
                  :monthDay="monthDay"
                  :outBasic="outBasic"
                  :startBasic="startBasic"
                  :endBasic="endBasic"
                  :breakBasic="breakBasic"
                  :start="start"
                  :end="send_end"
                  :rest="rest"
                  :attendance1="attendance1"
                  :attendance2="attendance2"
                  :remarks="remarks"
                ></RosterError>
                <CRow style="padding: 0px">
                  <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                      <thead>
                        <tr>
                          <th class="dayHeader"
                            style="
                              font-size: 11px;
                              width: 80px;
                              padding-bottom: 15px;
                            "
                          >
                            日付<br/>&nbsp;曜日
                          </th>
                          <th style="width: 120px">開始時刻</th>
                          <th style="width: 120px">終了時刻</th>
                          <th style="width: 120px"><font size="1px">5:00～22:00</font><br/>休憩</th>
                          <th style="width: 120px"><font size="1px">22:00～5:00</font><br/>夜勤休憩</th>
                          <th style="width: 120px">勤怠1</th>
                          <th style="width: 120px">勤怠2</th>
                          <th style="width: 300px">備考・作業内容</th>
                          <th style="width: 150px">
                            <select
                              class="custom-select"
                              style="width: 140px;"
                              v-model="bulkProjectId"
                              @change="applyBulkProject"
                              :disabled="bulkApplying || loading"
                            >
                              <option disabled value="">【一括変更】</option>
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                            プロジェクト名
                          </th>
                          <th style="width: 80px">作業</th>
                          <th style="width: 80px">時間外</th>
                          <th style="width: 80px">夜勤<br/></th>
                          <th style="width: 80px">法定休日</th>
                          <th style="width: 80px">控除</th>
                        </tr>
                        <!-- <input type="hidden" :value="setDay"> -->
                        <!-- <input type="hidden" :value="holiday"> -->
                        <input type="hidden" :value="endSetting" />
                      </thead>
                      <tbody
                        v-for="(day, index) in monthDay"
                        :key="index"
                        :class="getDayClass(day,attendance1[index])"
                      >
                        <tr>
                          <td style="width: 5%">
                            <label class="dayLabel">{{ monthDay[index].replace(' (', '\n(') }}</label>
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の開始時刻'"
                              rules="required"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 94px"
                                type="time"
                                maxlength="5"
                                v-model="start[index]"
                                :tabindex="[index] + 1"
                                @change="autoRestTime(index)"
                                @focus="startDefaultSet(index)"
                                @blur="start_check"
                              />
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の終了時刻'"
                              rules="required"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 94px"
                                type="time"
                                maxlength="5"
                                v-model="end[index]"
                                :tabindex="[index] + 2"
                                @change="autoRestTime(index)"
                                @focus="endDefaultSet(index)"
                                @blur="end_check"
                              />
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%">
                            <RestInput
                              :rest="rest[index]"
                              :index="index"
                              :post-buffer="postBuffer[index]"
                              :breakBasic="breakBasic[index]"
                              :flg="postWorkBreakFlg[index]"
                              :is-holiday="isHoliday(index)"
                              :actual-end="end[index]"
                              :end-basic="endBasic[index]"
                              :tabindex="index + 3"
                              :label="(index + 1) + '日の休憩'"
                              @update-rest="onUpdateRest"
                            />
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の夜勤休憩'"
                              rules="required"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 94px"
                                type="time"
                                maxlength="5"
                                v-model="nightRest[index]"
                                :tabindex="[index] + 4"
                                @focus="nightRestDefaultSet(index)"
                                @blur="nightRest_check"
                              />
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠1'"
                              rules="select"
                            >
                              <select
                                style="margin-bottom: 3px; width: 100px"
                                class="custom-select"
                                v-model="attendance1[index]"
                                :tabindex="[index] + 4"
                                @change="autoTime(index)"
                                @blur="attendance1_check"
                              >
                                <option value></option>
                                <option
                                  v-for="option in options"
                                  :value="option.id"
                                  :key="option.id"
                                >
                                  {{ option.name }}
                                </option>
                              </select>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠2'"
                              :rules="{ select }"
                            >
                              <select
                                style="margin-bottom: 3px; width: 100px"
                                class="custom-select"
                                v-model="attendance2[index]"
                                v-bind:disabled="devide[index]"
                                :tabindex="[index] + 5"
                                @blur="attendance2_check"
                              >
                                <option disabled value>未選択</option>
                                <option
                                  v-for="option2 in options2"
                                  :value="option2.id"
                                  :key="option2.id"
                                >
                                  {{ option2.name }}
                                </option>
                              </select>
                            </ValidationProvider>
                            <!-- 勤怠2の入力可否を記載 -->
                            <input type="hidden" :value="afternoon" />
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の備考・作業内容'"
                              rules="required"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 200px;"
                                type="text"
                                v-model="remarks[index]"
                                :tabindex="[index] + 6"
                                @blur="remarks_check"
                              />
                            </ValidationProvider>
                          </td>
                          <!-- プロジェクト -->
                          <td>
                            <select
                              class="custom-select"
                              style="margin-bottom: 3px; width: 140px;"
                              v-model="projectId[index]"
                              @change="onChangeProject(index)"
                            >
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                          </td>
                          <!-- 勤務時間のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <DailyWork
                              :monthDay="monthDay"
                              :index="index"
                              :total="dailyWorkResult"
                            ></DailyWork>
                          </td>
                          <!-- 時間外のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <OverTime
                              :dailyWorkResult="dailyWorkResult"
                              :workTimeUnit="workTimeUnit"
                              :workBasic="workBasic"
                              :index="index"
                              :attendance1="attendance1"
                              @updateOverTime="handleOvertimeUpdate"
                            ></OverTime>
                          </td>
                          <!-- 夜勤のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <NightWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :nightRest="nightRest"
                              :attendance1="attendance1"
                              :earlyMorningShiftBasic="earlyMorningShiftBasic"
                              :lateNightShiftBasic="lateNightShiftBasic"
                              :midnightBasic="midnightBasic"
                              :nightShiftTimes="nightShiftTimes"
                              :dateChangeShiftTimes="dateChangeShiftTimes"
                              :index="index"
                              @updateNightTime="handleNightTimeUpdate"
                            ></NightWork>
                          </td>
                          <!-- 休日のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <HolidayWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :index="index"
                              @updateHolidayWork="handleHolydayWorkUpdate"
                            ></HolidayWork>
                          </td>
                          <!-- 控除のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <Deduction
                              :monthDay="monthDay"
                              :startBasic="startBasic"
                              :endBasic="endBasic"
                              :breakBasic="breakBasic"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :attendance2="attendance2"
                              :index="index"
                              @updateDeduct="handleDeductionUpdate"
                            ></Deduction>
                          </td>
                        </tr>
                      </tbody>
                      <!-- DBから取得したID -->
                      <!-- <input v-for="(n, index) in monthDay" :key="index" type="hidden" v-model="id[index]" name="id" readonly> -->
                      <!-- 送信用としてTime型に変換した入力値の配列 -->
                      <input type="hidden" :value="sendStart" readonly />
                      <input type="hidden" :value="sendEnd" readonly />
                      <input type="hidden" :value="sendBreak" readonly />
                    </table>
                  </div>
                </CRow>
              </div>
            </form>
          </ValidationObserver>
        </CCardBody>
        <CCardBody>
          <CRow v-if="success3.length">
            <ul>
              <li
                style="color: blue"
                v-for="success in success3"
                :key="success"
              >
                {{ "※" + success }}
              </li>
            </ul>
          </CRow>
          <!-- 累計時間のコンポーネント呼出 -->
          <MonthlyData
            key="keyChild"
            :today="today"
            :fromExternal="fromExternal"
            :monthDay="monthDay"
            :outBasic="outBasic"
            :startBasic="startBasic"
            :endBasic="endBasic"
            :breakBasic="breakBasic"
            :earlyMorningShiftBasic="earlyMorningShiftBasic"
            :lateNightShiftBasic="lateNightShiftBasic"
            :midnightBasic="midnightBasic"
            :nightShiftTimes="nightShiftTimes"
            :dateChangeShiftTimes="dateChangeShiftTimes"
            :start="start"
            :end="send_end"
            :rest="rest"
            :nightRest="nightRest"
            :attendance1="attendance1"
            :attendance2="attendance2"
            :remarks="remarks"
            :year="year"
            :month="month"
            :totalTime="dailyWorkResult"
            :overTime="overTimeData"
            :nightWork="nightTimeData"
            :holiday="holiDayWorkData"
            :deduct="deductionData"
            :statusBtn="statusBtn || bulkApplying"
            :userId="user_id"
            :paid="paid"
            :instead="instead"
            :get_paid="get_paid"
            :addInstead="addInstead"
            :items="items"
            :projectId="projectId"
            :base-time-min="baseTimeMin"
            :base-time-max="baseTimeMax"
            @updateAllData="callList"
          ></MonthlyData>
        </CCardBody>
      </template>
    </CCard>
    <div v-if="globalLoading" class="loading-overlay" aria-live="polite" aria-busy="true">
      <CSpinner color="primary" style="width: 3rem; height: 3rem;" />
    </div>
  </div>
</template>

<script>
import MonthlyData from "./MonthlyData";
import DailyWork from "./DailyWork";
import Deduction from "./Deduction";
import HolidayWork from "./HolidayWork";
import NightWork from "./NightWork";
import OverTime from "./OverTime";
import RestInput from "./RestInput";
import axios from "axios";
import moment from "moment";
import ConstList from "./../ConstList";
import SubmissionConst from "./../submission_approval/ConstList";
import RosterError from "./RosterError";
import SaveButton from '../common/SaveButton';
export default {
  name: "Roster",
  components: {
    MonthlyData,
    DailyWork,
    Deduction,
    HolidayWork,
    NightWork,
    OverTime,
    RosterError,
    RestInput,
    SaveButton,
  },
  props: {
    externalUserId: [String, Number],
    externalYear: Number,
    externalMonth: Number,
    externalUserName: String,
    fromExternal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      user_id: "",
      user_name: "",
      project: "",
      projectList: [],
      outBasic: "05:00",
      startBasic: [],
      endBasic: [],
      breakBasic: [],
      preBuffer: [],
      postBuffer: [],
      workTimeUnit: [],
      workBasic: [],
      postWorkBreakFlg: [], 
      earlyMorningShiftBasic: "5:00",
      lateNightShiftBasic: "22:00",
      midnightBasic: "24:00",
      nightShiftTimes: "05:00",
      dateChangeShiftTimes: "02:00",
      monthDay: [],
      computedOvertime: [], // ここで計算した時間外労働のデータを保持
      id: [],
      date: [],
      hour: [],
      minutes: [],
      start: [],
      end: [],
      rest: [],
      nightRest: [],
      project_name: [],
      projectId: [],            // 日別の project_id を保持
      projectOptions: [],       // [{id, name, external?: true}]（所属外は external 表示のみ）
      attendance1: [],
      attendance2: [],
      options: [
        {
          id: ConstList.FULLTIME,
          name: "常勤",
        },
        {
          id: ConstList.MORNING_WORK,
          name: "午前出勤",
        },
        {
          id: ConstList.SHIFT,
          name: "シフト",
        },
        {
          id: ConstList.HOLIDAY,
          name: "休日",
        },
        {
          id: ConstList.PAID,
          name: "有給",
        },
        {
          id: ConstList.MORNING_PAID,
          name: "午前有給",
        },
        {
          id: ConstList.SUBSTITUTE,
          name: "代休",
        },
        {
          id: ConstList.MORNING_SUBSTITUTE,
          name: "午前代休",
        },
        {
          id: ConstList.DEDUCTION,
          name: "欠勤",
        },
        {
          id: ConstList.SPECIAL_HOLIDAY,
          name: "特休有給",
        },
        {
          id: ConstList.EARLY_MORNING,
          name: "早出出勤",
        },
      ],
      options2: [
        {
          id: ConstList.AFTERNOON_WORK,
          name: "午後出勤",
        },
        {
          id: ConstList.AFTERNOON_PAID,
          name: "午後有給",
        },
        {
          id: ConstList.AFTERNOON_SUBSTITUTE,
          name: "午後代休",
        },
      ],
      remarks: [],
      devide: [],
      items: [],
      baseTimeMin: [],
      baseTimeMax: [],
      start_time: [],
      end_time: [],
      break_time: [],
      today: [],
      success3: [],
      status: [],
      errors: [],
      displayFlg: false,
      id2_disable: false,
      send_end: [],
      total: [],
      showYearMonth: false,
      // 承認状態による登録ボタンの非活性化
      statusBtn: false,
      loading: false,
      bulkProjectId: "",// 一括変更用（初期は空欄）
      bulkApplying: false, 
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
  },
  methods: {
    // $setのタイミング次第では古い値を子コンポーネントに渡す可能性があるため、遅延を入れる
    // Vue2の仕様で、配列の中身が変わっても「参照が同じ」だとcomputedのメソッドが発火しないため、
    // すべての要素を新しい配列で再代入
    handleOvertimeUpdate({ index, value }) {
      this.$nextTick(() => {
        this.overTimeData = [...this.overTimeData];
      });
      this.$set(this.overTimeData, index, value);
    },
    handleNightTimeUpdate({ nights, index, value }) {
      this.$nextTick(() => {
        this.nightTimeData = [...nights];
      });
      this.$set(this.nightTimeData, index, value);
    },
    handleHolydayWorkUpdate({ index, value }) {
      this.$nextTick(() => {
        this.holiDayWorkData = [...this.holiDayWorkData];
      });
      this.$set(this.holiDayWorkData, index, value);
    },
    handleDeductionUpdate({ index, value }) {
      this.$nextTick(() => {
        this.deductionData = [...this.deductionData];
      });
      this.$set(this.deductionData, index, value);
    },
    isHoliday(index) {
      if (this.attendance1[index] === ConstList.HOLIDAY
          || this.attendance1[index] === ConstList.PAID
          || this.attendance1[index] === ConstList.SUBSTITUTE
          || this.attendance1[index] === ConstList.DEDUCTION) {
            //休日や有給休暇、代休、欠勤の場合、trueを返す
        return true;
      } else {
        return false;
      }
    },

    onUpdateRest({ index, value }) {
      this.$set(this.rest, index, value);
    },

    // DBから一覧呼出メソッド
    callList: function () {
      this.loading = true;
      this.monthDay = [];
      this.total = [];
      this.start = [];
      this.end = [];
      this.rest = [];
      this.night_rest = [];
      this.project_name = [];
      this.projectOptions = []
      this.attendance1 = [];
      this.attendance2 = [];
      this.remarks = [];
      this.dailyWork = [];
      this.overTimeData = [];
      this.nightTimeData = [];
      this.holiDayWorkData = [];
      this.deductionData = [];
      this.preBuffer = [];
      this.postBuffer = [];
      this.postWorkBreakFlg = [];
      this.workTimeUnit = [];
      this.workBasic = [];
      (this.status = []), (this.errors = []), (this.displayFlg = false);
      this.statusBtn = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/select", {
          params: {
            userId: this.user_id,
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          this.item = [];
          this.monthDay = [];
          this.items = response.data;
          this.displayFlg = true;
          this.showYearMonth = true;
          this.selectYear = this.year;
          this.selectMonth = this.month;
          const paddedMonth = String(this.month).padStart(2, "0"); // "01"〜"12"

          const startDate = moment(`${this.year}-${paddedMonth}-01`)
            .startOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          const endDate = moment(`${this.year}-${paddedMonth}-01`)
            .endOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          while (startDate.unix() <= endDate.unix()) {
            this.monthDay.push(startDate.format("D日 (dd)"));
            startDate.add(1, "days");
          }

          // ユーザID取得
          if (this.items?.length && !this.user_id) {
            this.user_id = this.items[0][ConstList.USER_ID];
          }

          // ユーザー所属プロジェクト一覧を取得
          return axios
            .get(process.env.VUE_APP_API_ORIGIN + "/projects", {
            })
            .then(({ data: projList }) => {
            // 1) 所属（数値IDで正規化）
            const belong = (projList || []).map(p => ({ id: +p.id, name: p.name }));
            const belongIdSet = new Set(belong.map(p => p.id));

            // 2) 履歴に出てくるプロジェクト（存在するIDだけ拾う）
            const fromItems = (this.items || [])
              .map(r => {
                const id = r[ConstList.PROJECT_ID];
                if (id === null || id === undefined || isNaN(+id)) return null;
                return { id: +id, name: r[ConstList.PROJECT_NAME] || `(ID:${+id})` };
              })
              .filter(Boolean);

            // 3) 所属＋履歴をIDでユニーク化し、所属外には external フラグ
            const map = new Map();
            [...belong, ...fromItems].forEach(p => {
              if (!map.has(p.id)) {
                map.set(p.id, {
                  id: p.id,
                  name: p.name,
                  external: !belongIdSet.has(p.id),
                });
              }
            });
            this.projectOptions = Array.from(map.values());

            // 4) 各日の選択値を一気に作る（saved がなければ先頭を既定）
            const defaultId = this.projectOptions[0]?.id ?? null;
            this.projectId = (this.items || []).map(r => {
              const saved = r[ConstList.PROJECT_ID];
              return (saved !== null && saved !== undefined && !isNaN(+saved))
                ? +saved
                : defaultId;
            });
            
            for (let i = 0; i < this.items.length; i++) {
              const days = moment(this.items[i][ConstList.DATE]);
              days.format("YYYY-MM-DD");
              this.id.splice(i, 1, this.items[i][ConstList.ID]);
              this.user_id = this.items[i][ConstList.USER_ID];
              this.start.splice(i, 1, this.items[i][ConstList.START_TIME]);
              this.end.splice(i, 1, this.items[i][ConstList.END_TIME]);
              this.rest.splice(i, 1, this.items[i][ConstList.BREAK_TIME]);
              this.nightRest.splice(i, 1, this.items[i][ConstList.NIGHT_REST]);
              this.baseTimeMin.splice(i, 1, this.items[i][ConstList.BASE_TIME_MIN] ?? null);
              this.baseTimeMax.splice(i, 1, this.items[i][ConstList.BASE_TIME_MAX] ?? null);
              this.attendance1.splice(i, 1, this.items[i][ConstList.ATTENDANCE1]);
              this.attendance2.splice(i, 1, this.items[i][ConstList.ATTENDANCE2]);
              this.remarks.splice(i, 1, this.items[i][ConstList.REMARKS]);
              this.startBasic.splice(i, 1, this.items[i][ConstList.BASIC_START_TIME]);
              this.endBasic.splice(i, 1, this.items[i][ConstList.BASIC_END_TIME]);
              this.breakBasic.splice( i, 1, this.items[i][ConstList.BASIC_BREAK_TIME]);
              this.preBuffer.splice(i, 1, this.items[i][ConstList.PRE_BUFFER] || "");
              this.postBuffer.splice(i, 1, this.items[i][ConstList.POST_BUFFER] || "");
              this.workTimeUnit.splice(i, 1, this.items[i][ConstList.WORK_TIME_UNIT] || "");
              this.workBasic.splice(i, 1, this.items[i][ConstList.WORK_BASIC] || "");
              this.postWorkBreakFlg.splice(i, 1, !!this.items[i][ConstList.POST_WORK_BREAK_FLG]);
              this.status.splice(i, 1, this.items[i][ConstList.STATUS]);

              const status = this.items[i][ConstList.STATUS];

              if (status === ConstList.APPROVAL) {
                // 承認済 → t_monthly
                this.paid = this.items[i][ConstList.PAID_PRE] ?? "0";
                this.get_paid = this.items[i][ConstList.PAID_ADDED] ?? "0";
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE] ?? "0";
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED] ?? "0";
              } else {
                // 差戻・未申請・初回保存前 → t_user 由来
                this.paid = this.items[i][ConstList.PAID_PRE];
                this.get_paid = this.items[i][ConstList.PAID_ADDED];
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE];
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED];
              }

              // nullを空文字に統一
              this.dailyWork.splice(i, 1, this.items[i][ConstList.WORK_TIME] || "");
              this.overTimeData.splice(i, 1, this.items[i][ConstList.OVER_TIME] || "");
              this.nightTimeData.splice(i, 1, this.items[i][ConstList.NIGHT_WORK] || "");
              this.holiDayWorkData.splice(i, 1, this.items[i][ConstList.HOLIDAY] || "");
              this.deductionData.splice(i, 1, this.items[i][ConstList.DEDUCT] || "");
            }

            this.$nextTick(() => {
              this.$forceUpdate();
            });

            if (this.status[0] == ConstList.APPROVAL_PENDING) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
              this.statusBtn = true;
            }

            // 承認済み状態はメッセージ表示とボタン非活性化
            if (this.status[0] == ConstList.APPROVAL) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
              this.statusBtn = true;
            }
            // 初回表示（新規月含む）でも“その日のプロジェクト基準”で計算できるよう、日別に基準を流し込む
            return this.hydrateDailyBasicsByProject();
          })
        })
        .catch((error) => {
          this.displayFlg = false;
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(()=> {
              alert(ConstList.SYSTEM_ERROR);
            })
          .catch(()=> {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDayClass(day,attendance) {
      const dayOfWeek = day.substring(
        day.lastIndexOf("(") + 1,
        day.lastIndexOf(")")
      );
      if (dayOfWeek === "土") return {blue: dayOfWeek === "土"};
      else if (attendance === 5) return {red: attendance === 5};
    },
    // 時間の自動入力
    autoTime: function (index) {
      const id1 = this.attendance1[index];

      if (
        id1 === ConstList.PAID ||
        id1 === ConstList.SUBSTITUTE ||
        id1 === ConstList.SPECIAL_HOLIDAY ||
        id1 === ConstList.DEDUCTION ||
        id1 === ConstList.HOLIDAY
      ) {
        this.start.splice(index, 1, "");
        this.end.splice(index, 1, "");
        this.rest.splice(index, 1, "");
        this.nightRest.splice(index, 1, "");
      }
    },
    // 休憩時間操作
    autoRestTime(index) {
      const start = this.start[index];
      const end = this.end[index];
      if (!start || !end) {
        this.rest.splice(index, 1, null);
        return;
      }

      const rBasic = moment.duration(this.breakBasic[index], "HH:mm");
      const postBuffer = moment.duration(this.postBuffer[index] ?? "00:00", "HH:mm");
      const endTime = moment.duration(end, "HH:mm");
      const endBase = moment.duration(this.endBasic[index], "HH:mm");

      let restTime = rBasic.clone();

      if (this.postWorkBreakFlg[index]) {
        const diffMin = endTime.asMinutes() - endBase.asMinutes();
        if (diffMin >= postBuffer.asMinutes()) {
          restTime.add(postBuffer);
        } else if (diffMin > 0) {
          restTime.add(moment.duration(diffMin, "minutes"));
        }
      }

      const h = String(restTime.hours()).padStart(2, "0");
      const m = String(restTime.minutes()).padStart(2, "0");
      this.rest.splice(index, 1, `${h}:${m}`);
    },
    start_check: function () {
      this.$refs.error.start_empty();
      this.$refs.error.start_regex();
    },
    end_check: function () {
      this.$refs.error.end_empty();
      this.$refs.error.end_regex();
    },
    rest_check: function () {
      this.$refs.error.rest_empty();
      this.$refs.error.rest_regex();
    },
    nightRest_check: function () {
      this.$refs.error.nightRest_empty();
      this.$refs.error.nightRest_regex();
    },
    attendance1_check: function () {
      this.$refs.error.attendance1_empty();
    },
    attendance2_check: function () {
      this.$refs.error.attendance2_empty();
    },
    remarks_check: function () {
      this.$refs.error.remarks_empty();
    },
    // ファイル読み込み
    readfile: function(e) {
      if(typeof e.target === "undefined") return null;
      const file = e.target.files[0];
      const reader = new FileReader();
      let start = this.start;
      let end = this.end;

      reader.onload = function() {
        const list = reader.result.split("\n");
        let splitChar = "	";  // 区切り文字
        list.forEach((ele_row,idx) => {
          let element = ele_row.split(splitChar);
          element.forEach((tm,i) => {
            if(tm.indexOf(':') == -1){
              element[i]="";
            } else {
              const [hour, minute] = tm.split(':');
              const HH = hour < 10 ? "0" + hour : hour;
              const MM = minute;
              element[i] = (HH + ":" + MM).substring(0,5);
            }
          });
          start.splice(idx, 1, element[0]);
          end.splice(idx,   1, element[1]);
        });
      }

      reader.readAsText( file )
      return null;
    },
    /* なぜかファンクションとして認識できない、技術的に解決したら上記関数から呼び出し
    hhMmFormat(element){
        const [hour, minute] = element.split(':');
        const HH = hour < 10 ? "0" + hour : hour;
        const MM = minute < 10 ? "0" + minute : minute;
        return HH + ":" + MM;
    }*/
    autoFillDefaultTimes(i) {
      const s = moment.duration(this.start[i], "HH:mm");
      if (s.hours() === 0 && s.minutes() === 0 && this.attendance1[i] === ConstList.FULLTIME) {
        this.start[i] = this.startBasic[i];
        this.end[i] = this.endBasic[i];
        this.rest[i] = this.breakBasic[i];
      }
    },
    formatDurationToHHMM(duration) {
      const hours = Math.abs(duration.hours()) < 10 ? "0" + Math.abs(duration.hours()) : Math.abs(duration.hours());
      const minutes = Math.abs(duration.minutes()) < 10 ? "0" + Math.abs(duration.minutes()) : Math.abs(duration.minutes());
      return (duration.asMinutes() < 0 ? "-" : "") + hours + ":" + minutes;
    },
    // 表示用のラベル変換
    getStatusLabel(status) {
      if (!status) {
        return ConstList.UNSUBMITTED; // '未申請'
      }
      return status;
    },
    // 承認状態の識別
    statusColor(status) {
      const label = this.getStatusLabel(status);
      switch (label) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // プロジェクトID配列から日別の基準を流し込む（Promise版）
    hydrateDailyBasicsByProject() {
      const ids = Array.from(new Set(this.projectId.filter(v => v != null)));
      if (!ids.length) return Promise.resolve(); // 呼び出し元のthenチェーンを壊さない

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basics", {
          params: { ids: ids.join(",") }
        })
        .then(({ data }) => {
          // 例：data = { "101": {...}, "102": {...} }
          this.projectId.forEach((pid, i) => {
            const p = data[String(pid)];
            if (!p) return;
            this.$set(this.startBasic, i, p.start ?? "");
            this.$set(this.endBasic,   i, p.end ?? "");
            this.$set(this.breakBasic, i, p.break ?? "");
            this.$set(this.preBuffer,  i, p.preBuffer ?? "00:00");
            this.$set(this.postBuffer, i, p.postBuffer ?? "00:00");
            this.$set(this.workTimeUnit, i, p.workTimeUnit ?? "00:00");
            this.$set(this.workBasic,    i, p.workBasic ?? "00:00");
            this.$set(this.postWorkBreakFlg, i, !!p.postWorkBreakFlg);
          });
          // 参照替えで子コンポーネント再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${e}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },

    // プロジェクト選択変更時（Promise版）
    onChangeProject(index) {
      const pid = this.projectId[index];
      if (pid == null) return;

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basic", {
          params: { projectId: pid }
        })
        .then(({ data: p }) => {
          this.$set(this.startBasic, index, p.start ?? "");
          this.$set(this.endBasic,   index, p.end ?? "");
          this.$set(this.breakBasic, index, p.break ?? "");
          this.$set(this.preBuffer,  index, p.preBuffer ?? "00:00");
          this.$set(this.postBuffer, index, p.postBuffer ?? "00:00");
          this.$set(this.workTimeUnit, index, p.workTimeUnit ?? "00:00");
          this.$set(this.workBasic,    index, p.workBasic ?? "00:00");
          this.$set(this.postWorkBreakFlg, index, !!p.postWorkBreakFlg);

          // 直ちに休憩再計算（postWorkBreakFlg / endBasic の影響を反映）
          this.autoRestTime(index);

          // 参照替えで子を再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${e}`)
            .then(() => alert(ConstList.SYSTEM_ERROR))
            .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
        });
    },
    applyBulkProject() {
      if (!this.bulkProjectId) return; // 空は処理しない

      this.bulkApplying = true;
      const pid = this.bulkProjectId;
      this.projectId = this.projectId.map(() => pid);

      const done = () => {
        this.bulkApplying = false;
        this.bulkProjectId = "";
      };

      if (this.hydrateDailyBasicsByProject) {
        const r = this.hydrateDailyBasicsByProject();
        if (r && typeof r.then === "function") {
          r.then(done).catch(done);
        } else {
          done();
        }
      } else {
        done();
      }
    },
  },
  computed: {
    // 勤務時間の自動計算
    dailyWorkResult() {
      const result = [];
      for (let i = 0; i < this.start.length; i++) {
        const s = moment.duration(this.start[i], "HH:mm");
        const e = moment.duration(this.end[i], "HH:mm");
        const restDuration = moment.duration(this.rest[i] || this.breakBasic[i], "HH:mm");
        const nightRestDuration = moment.duration(this.nightRest?.[i] ?? "00:00", "HH:mm");

        let actualStart = s.clone();
        const startBasicTime = moment.duration(this.startBasic[i], "HH:mm");

        // 入力が揃っていない日は null
        if (!this.start[i] || !this.end[i]) {
          result.push(null);
          continue;
        }

        // 始業時刻補正（遅刻除外）
        if (
          this.attendance1[i] === ConstList.FULLTIME ||
          this.attendance1[i] === ConstList.MORNING_WORK
        ) {
          const preBuffer = moment.duration(this.preBuffer[i] ?? "00:00", "HH:mm");
          const preBufferStart = startBasicTime.clone().subtract(preBuffer);

          if (
            actualStart.asMinutes() >= preBufferStart.asMinutes() &&
            actualStart.asMinutes() < startBasicTime.asMinutes()
          ) {
            actualStart = startBasicTime;
          }
        }

        // 終了時刻の補正（00:00 の場合は翌日扱い）
        let actualEnd = e.clone();
        if (actualEnd.asMinutes() <= actualStart.asMinutes()) {
          actualEnd = actualEnd.add(24, "hours");
        }

        // 勤務時間計算
        let workDuration = actualEnd.clone().subtract(actualStart).subtract(restDuration).subtract(nightRestDuration);

        result.push(this.formatDurationToHHMM(workDuration));
      }

      return [...result];
    },

    // 勤怠の入力制御
    afternoon: function () {
      const afternoon = this.devide;
      const list = this.attendance2;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (
          this.attendance1[i] === ConstList.MORNING_WORK ||
          this.attendance1[i] === ConstList.MORNING_PAID ||
          this.attendance1[i] === ConstList.MORNING_SUBSTITUTE ||
          this.attendance1[i] === ConstList.EARLY_MORNING
        ) {
          afternoon.splice(i, 1, false);
        } else {
          list.splice(i, 1, "");
          afternoon.splice(i, 1, true);
        }
      }
      return afternoon;
    },
    // 勤怠2のバリデーション条件
    select: function () {
      let disable = this.id2_disable;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (
          this.attendance1[i] === ConstList.MORNING_WORK ||
          this.attendance1[i] === ConstList.MORNING_PAID ||
          this.attendance1[i] === ConstList.MORNING_SUBSTITUTE ||
          this.attendance1[i] === ConstList.EARLY_MORNING
        ) {
          disable = true;
        } else {
          disable = false;
        }
      }
      return disable;
    },
    // 送信用の開始時間の配列作成
    sendStart: function () {
      let sendS = this.start_time;
      for (let i = 0; i < this.start.length; i++) {
        const sTime = this.start[i] || "09:00";
        sendS.splice(i, 1, sTime + ":00");
      }
      return sendS;
    },
    // 送信用の終了時間の配列作成
    sendEnd: function () {
      let sendE = this.end_time;
      for (let i = 0; i < this.end.length; i++) {
        const eTime = this.end[i] || "18:00";
        sendE.splice(i, 1, eTime + ":00");
      }
      return sendE;
    },
    // 送信用の休憩時間の配列作成
    sendBreak: function () {
      let sendB = this.break_time;
      for (let i = 0; i < this.rest.length; i++) {
        const bTime = this.rest[i] || "01:00";
        sendB.splice(i, 1, bTime + ":00");
      }
      return sendB;
    },
    // 登録・更新ボタンの活性非活性
    activeButton: function () {
      const start = this.start;
      const end = this.end;
      const rest = this.rest;
      const id1 = this.attendance1;
      const remarks = this.remarks;
      if (
        start[0] !== "" &&
        end[0] !== "" &&
        rest[0] !== "" &&
        id1[0] !== 0 &&
        remarks[0] !== ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    // 終了時刻が0時を過ぎた場合の数値調整
    endSetting: function () {
      let setting = this.send_end;
      for (let i = 0; i < this.end.length; i++) {
        if (this.end[i] === "" || this.end[i] === null) {
          // null または空文字の場合に null を代入する
          setting.splice(i, 1, null);
        } else {
          let start = moment.duration(this.start[i], "HH:mm");
          let end = moment.duration(this.end[i], "HH:mm");
          let hour = 0;
          let minute = 0;
          if (end.hours() < start.hours()) {
            hour = end.hours() + 24;
            minute = end.minutes();
            const hours = hour < 10 ? "0" + hour : hour;
            const minutes = minute < 10 ? "0" + minute : minute;
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          } else {
            const hours = end.hours() < 10 ? "0" + end.hours() : end.hours();
            const minutes =
              end.minutes() < 10 ? "0" + end.minutes() : end.minutes();
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          }
        }
      }
      return 0;
    },
    globalLoading() {
      return this.loading || this.bulkApplying;
    },
  },
  mounted() {
    if (this.fromExternal) {
      // 管理者が対象ユーザーを表示する場合（Info.vue 経由）
      this.user_id = this.externalUserId;
      this.year = this.externalYear;
      this.month = this.externalMonth;
      this.user_name = this.externalUserName;
      this.callList(); // ← 外から渡されたユーザで初回表示
    } else {
      // 一般ユーザーの場合（ログインユーザー自身）
      const today = moment();
      if (today.date() < 10) {
        today.subtract(1, "months");
      }
      this.year = Number(today.format("YYYY"));
      this.month = Number(today.format("M"));
      this.user_id = this.$store.state.user.id;
      this.user_name = this.$store.state.user.name;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

button:disabled {
  cursor: not-allowed;
}

.dayHeader { white-space: pre; }  /* <br> だけで改行。自動折返しなし */
.dayLabel  { white-space: pre; }  /* \n だけで改行。自動折返しなし */
</style>
